import * as methods from '../methods';
import { Resource } from '../Resource';
import * as transformers from '../transformers';
const rootPath = 'option_plot_links';
export const fromRaw = {
    get: ({ end, id, option, plot, plot_name, remaining_tokens, start, station_id }) => ({
        end,
        id,
        optionCode: option,
        plotId: plot,
        plotName: plot_name,
        remainingTokens: remaining_tokens,
        start,
        stationId: station_id
    })
};
const plotOptionActivations = Resource((requesterBuilder) => {
    const getMany = (query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            method: 'GET',
            transform: transformers.paginatedResponse(fromRaw.get),
            params: {
                query: {
                    offset: query?.offset,
                    limit: query?.limit,
                    code: query?.optionCode,
                    organization: query?.organizationId,
                    plots: query?.plotIds
                }
            }
        }
    });
    const get = methods.get({
        rootPath,
        requesterBuilder,
        fromRaw: fromRaw.get
    });
    return {
        delete: methods.deletion({
            rootPath,
            requesterBuilder,
            buildKeysToInvalidate: (id) => [get(id).invalidationKey, getMany().invalidationKey]
        }),
        get,
        getAllPages: methods.getAllPages({
            getMany
        }),
        getMany,
        getPage: methods.getPage({ getMany }),
        requestReActivation: (optionId) => methods.create({
            requesterBuilder,
            rootPath: `${rootPath}/${optionId}/reactivate`,
            fromRaw: () => undefined,
            parse: async (res) => res,
            toRaw: () => ({ displayed: true }),
            method: 'PUT'
        })()
    };
});
export default plotOptionActivations;
